// ASSETS

// STYLES
import { CardsContainer, Card, DropdownContainer, DropdownButton, DropdownList, DropdownItem } from "./ScrollCardsMenuStyled";

// LIBRARIES
import { useState, useEffect } from "react";
import { useMediaQuery } from "react-responsive";

// MISC
import { COLORS } from "constants/variables";
import { ScrollCardsMenuProps } from "./ScrollCardsMenuModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";

// REDUX

// COMPONENTS
import CustomText from "components/Atoms/CustomText/CustomText";

const ScrollCardsMenu: React.FC<ScrollCardsMenuProps> = ({ cards }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(cards[0]);
  const isMobile = useMediaQuery({ maxWidth: 767 });

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      if (isOpen) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [isOpen]);

  // EVENT HANDLERS
  const handleScroll = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",       
      });
    }
  };

  const handleCardSelect = (card: any) => {
    setSelectedCard(card);
    handleScroll(card.id);
    if (isMobile) {
      setIsOpen(false);
    }
  };

  const toggleDropdown = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  if (isMobile) {
    return (
      <DropdownContainer>
        <DropdownButton onClick={toggleDropdown} isOpen={isOpen}>
          <CustomText
            type={TextType.H5}
            text={selectedCard?.title || 'Select'}
            color={COLORS.AbsoluteWhite}
          />
        </DropdownButton>
        {isOpen && (
          <DropdownList isOpen={isOpen}>
            <div>
              {cards.map((card) => (
                <DropdownItem 
                  key={card.id} 
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCardSelect(card);
                  }}
                >
                  <CustomText
                    type={TextType.H5}
                    text={card.title}
                    color={COLORS.RaisinBlack}
                  />
                </DropdownItem>
              ))}
            </div>
          </DropdownList>
        )}
      </DropdownContainer>
    );
  }

  return (
    <CardsContainer>
      {cards.map((card) => (
        <Card key={card.id} onClick={() => handleScroll(card.id)}>
          <CustomText
            type={TextType.H5}
            text={card.title}
            color={COLORS.AbsoluteWhite}
          />
        </Card>
      ))}
    </CardsContainer>
  )
};

export default ScrollCardsMenu;
